const normalizeText = (value) => String(value || "").trim();

const parsePayload = (value) => {
  if (!value) return {};
  if (typeof value === "object" && !Array.isArray(value)) return value;
  if (typeof value !== "string") return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

const firstText = (...values) => {
  for (const value of values) {
    const text = normalizeText(value);
    if (text) return text;
  }
  return "";
};

export const getCanonicalCampaignDisplayName = (campaign = {}) => {
  if (campaign == null) return "";
  if (typeof campaign === "string") return normalizeText(campaign);
  if (typeof campaign !== "object") return "";

  const strategyPayload = parsePayload(campaign.strategy_payload || campaign.strategyPayload);
  const externalReporting =
    strategyPayload.externalReporting && typeof strategyPayload.externalReporting === "object"
      ? strategyPayload.externalReporting
      : {};

  return firstText(
    campaign.metaCampaignName,
    campaign.meta_campaign_name,
    campaign.liveMetaCampaignName,
    campaign.live_meta_campaign_name,
    campaign.meta?.campaign?.name,
    campaign.meta?.name,
    campaign.externalCampaignName,
    campaign.external_campaign_name,
    campaign.linkedExternalCampaignName,
    campaign.linked_external_campaign_name,
    externalReporting.externalCampaignName,
    externalReporting.external_campaign_name,
    campaign.reportingCampaignName,
    campaign.reporting_campaign_name,
    strategyPayload.reportingCampaignName,
    strategyPayload.reporting_campaign_name,
    campaign.displayCampaignName,
    campaign.display_campaign_name,
    campaign.canonicalCampaignName,
    campaign.canonical_campaign_name,
    /*
     * The governed campaign_name column outranks the strategy_payload copy.
     *
     * strategy_payload.campaignName is a planning-time SNAPSHOT of the name, not
     * a second source of truth. Renaming a campaign updates the column and
     * leaves the payload untouched, so ranking the payload first made the stale
     * planning name outrank the campaign's real name — media campaign 44 is
     * named "Never Stop Chasing" but rendered as its pre-rename payload name
     * everywhere this resolver is consumed. The payload stays as a last-resort
     * fallback for rows that predate the column being populated.
     */
    campaign.campaign_name,
    campaign.campaignName,
    strategyPayload.campaignName,
    strategyPayload.campaign_name,
    campaign.name
  );
};
